import classNames from "classnames";
import React from "react";

export const SkeletonBone = ({ className }) => (
  <div className={classNames("animate-pulse rounded-[3px] bg-purple-100", className)} />
);

// Builds and PvP pages: hero selector, data details, stat priorities, talent tree, gear guide
export const BuildsPageSkeleton = () => (
  <div className="w-full flex flex-col gap-[12px]">
    <SkeletonBone className="h-[96px] w-full" />
    <SkeletonBone className="h-[18px] w-[320px] max-w-full" />
    <SkeletonBone className="h-[120px] w-full" />
    <SkeletonBone className="h-[640px] w-full" />
    <SkeletonBone className="h-[240px] w-full" />
  </div>
);

// Gear, trinkets, gems-and-enchants, and alternate builds pages: subtitle, description, tables
export const TablePageSkeleton = () => (
  <div className="w-full flex flex-col gap-[12px]">
    <SkeletonBone className="h-[28px] w-[420px] max-w-full" />
    <SkeletonBone className="h-[16px] w-[560px] max-w-full" />
    <SkeletonBone className="h-[320px] w-full mt-[12px]" />
    <SkeletonBone className="h-[320px] w-full" />
  </div>
);

// Tier list page: header row + spec rows matching the real table dimensions
export const TierListTableSkeleton = ({ rows = 15 }) => (
  <div className="w-full flex flex-col gap-[2px] mt-[12px]">
    <SkeletonBone className="h-[41px] w-full" />
    {Array.from({ length: rows }, (_, i) => (
      <SkeletonBone key={i} className="h-[54px] w-full" />
    ))}
  </div>
);
